// extracted by mini-css-extract-plugin
module.exports = {"editContainer":"styles_editContainer__f6KaF","addComments":"styles_addComments__hTkIR","buttonContainer":"styles_buttonContainer__yE39k"};